import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/subDays/index.js';

var require$$14 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$14 as default };
